export const MOCK_TOWNSQUARE = {
	data: {
		graphStore: {
			cypherQueryV2: {
				edges: [
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'project',
									value: {
										id: 'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project/19cd77a5-2573-428c-a063-f18898ab0bc8',
										data: {
											__typename: 'TownsquareProject',
											iconData:
												'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAC5ElEQVR4Xu2aO2/TUBiG+4MQYo5bISExwAQTahEDEwMDEgsDMKImLUIwUAmkioGGm0B04zKhJmm5tAJBSodKFISaUKCCAiWXJj74g0YK7/Gx/TlW5dNzHulZYvd13i927Tju67NYLBaLxWIJITNS2tWfLdx0soVPniKlVjO5wo2B0amd+P57wskVD3vhTZ8NptWG5xD2iAV98o5e5Ts2EtkTNnd7DNfFPPZh44Ws+ATrYhX7sPFCXJ9gXXSxDxufUK3EPmwwUDexDxsM1E3swwYDVR4ZnxP7Ls5Ir4d5PP9aei1JsQ8bDFR5ZnJBLH1dFwfHnkvLgmy22uL0/QXp9aTEPmwwUCUNgKiu1cXg1VlpuUqi7boi92BRWpaE2IcNBqrsDIBYq22IY9dfSev42cH1HC9+kJb3KvZhg4EquwdA1JotcfJ2WVoPRe7MLouBnLxeXLEPGwxUiQMgmi1XnJ0MPr79eFheEbtHitK6ccQ+bDBQpd8ACDq+Rx+pj28VxcVVsed8SVqfK/Zhg4EqVQPoMDHzUfobMojy8g+x/xL/1Not9mGDgSrDBkDcm6tIx3cY776siwOXn0nbiyr2YYOBKqMMgHg8//m/4zsKle81cehK9FNrt9iHDQaqjDoA4sX7b2Lvhem/fxeV1V9NcfTaS2m7YWIfNhiokjMA4m3lp3d8P8WXA/ndaIkTt95I2w4S+7DBQJXcARB0fHOpb7TFqbvz0vZVYh82GKgyzgDiQqfWbMRLZ+zDBgNVbuUACLp0HnuyJL0PFPuwwUCVdgBbOIBtcwgY/U/Q6NOg0RdCRl8KG/1lyNivw0bfEDH6lpjRN0WNvi1u9A8jRv80ZvyPo2kV+7DBQN3EPmwwUDexDxvHPiSV6kdjw+z9MTl69tYnWA+HpyawDxt63NT59+ytvIF0W8+cK+3APrHwwoYcvYZQ7x8uDGKPntjcE/KeFZ8NpsUK7faJffIWi8VisVi2NX8A+6Mq6AD3yLMAAAAASUVORK5CYII=',
											key: 'ATLAS-93175',
											name: 'Flock Ongoing Backfills',
											uuid: '19cd77a5-2573-428c-a063-f18898ab0bc8',
											creationDate: '2025-05-08',
											url: 'https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-93175',
											startDate: '2025-10-23',
											latestUpdateDate: '2025-11-27T00:23:33.562699Z',
											userUpdateCount: 5,
											watcherCount: 16,
											watching: true,
											isJiraWorkItemsLimitReached: false,
											mercuryProjectName: 'Flock Ongoing Backfills',
											mercuryProjectUrl:
												'https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-93175',
											mercuryProjectIcon:
												'https://home.atlassian.com/gateway/api/townsquare/s/a436116f-02ce-4520-8fbb-7301462a1674/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/icon/project/ATLAS-93175?t=1764203013582&appearance=ROUNDED_SQUARE&theme=LIGHT',
											mercuryProjectKey: 'ATLAS-93175',
											mercuryTargetDateStart: '2025-10-01T00:00Z',
											mercuryTargetDateEnd: '2025-12-31T00:00Z',
											mercuryTargetDateType: 'QUARTER',
											mercuryProjectProviderName: 'ATLAS',
											icon: {
												id: '23e9',
											},
											latestUserUpdate: {
												id: 'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project-update/942e97e7-be1c-4e8c-a51f-d9364dcd0b68',
											},
											workspace: {
												id: 'b4bae280-23b7-4f3a-a5be-0b7f351e5fa4',
											},
											mercuryProjectStatus: {
												__typename: 'TownsquareMercuryProjectStatusDto',
											},
											mercuryOriginalProjectStatus: {
												__typename: 'TownsquareMercuryOriginalProjectStatusDto',
											},
											mercuryProjectType: {
												__typename: 'TownsquareMercuryProjectTypeDto',
											},
											mercuryProjectOwner: {
												__typename: 'AtlassianAccountUser',
											},
											owner: {
												__typename: 'AtlassianAccountUser',
											},
											isPrivate: false,
											isArchived: false,
											id: 'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project/19cd77a5-2573-428c-a063-f18898ab0bc8',
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'project',
									value: {
										id: 'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project/72a54100-f650-44a4-a698-68a4b49d91f0',
										data: {
											__typename: 'TownsquareProject',
											iconData:
												'data:image/png;base64,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',
											key: 'ATLAS-99619',
											name: 'Collab Context in Flock & Multi Region',
											uuid: '72a54100-f650-44a4-a698-68a4b49d91f0',
											creationDate: '2025-07-16',
											url: 'https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-99619',
											startDate: '2025-08-02',
											latestUpdateDate: '2025-11-07T23:26:36.855580Z',
											userUpdateCount: 10,
											watcherCount: 13,
											watching: true,
											isJiraWorkItemsLimitReached: false,
											mercuryProjectName: 'Collab Context in Flock & Multi Region',
											mercuryProjectUrl:
												'https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-99619',
											mercuryProjectIcon:
												'https://home.atlassian.com/gateway/api/townsquare/s/a436116f-02ce-4520-8fbb-7301462a1674/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/icon/project/ATLAS-99619?t=1762734636956&appearance=ROUNDED_SQUARE&theme=LIGHT',
											mercuryProjectKey: 'ATLAS-99619',
											mercuryTargetDateStart: '2026-01-16T00:00Z',
											mercuryTargetDateEnd: '2026-01-16T00:00Z',
											mercuryTargetDateType: 'DAY',
											mercuryProjectProviderName: 'ATLAS',
											icon: {
												id: '1f60e',
											},
											latestUserUpdate: {
												id: 'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project-update/6063aa1b-4b07-4572-922b-81c536dde383',
											},
											workspace: {
												id: 'b4bae280-23b7-4f3a-a5be-0b7f351e5fa4',
											},
											mercuryProjectStatus: {
												__typename: 'TownsquareMercuryProjectStatusDto',
											},
											mercuryOriginalProjectStatus: {
												__typename: 'TownsquareMercuryOriginalProjectStatusDto',
											},
											mercuryProjectType: {
												__typename: 'TownsquareMercuryProjectTypeDto',
											},
											mercuryProjectOwner: {
												__typename: 'TownsquareMercuryProjectOwnerDto',
											},
											owner: {
												__typename: 'AtlassianAccountUser',
											},
											isPrivate: false,
											isArchived: false,
											id: 'ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project/72a54100-f650-44a4-a698-68a4b49d91f0',
										},
									},
								},
							],
						},
					},
					// ... remaining edges copied from the JSON ...
				],
			},
		},
	},
	extensions: {
		gateway: {
			request_id: '032b36b2-5310-45ba-95e7-2dd24d2a6e86',
			tId: '032b36b2531045ba95e72dd24d2a6e86',
			crossRegion: false,
			edgeCrossRegion: false,
		},
	},
} as const;
